import { CartLinkedEntitlementsSchema, CartProductSchema } from '../../types';
import { State } from '../types';
import { getProductStatuses, getShallowDiffObject } from './utils';

/**
 * Function to get the selected collection instance line item with updated offering id and offering name
 * @param initialProducts - initial products in the cart
 * @param selectedProducts - selected products in the cart
 * @param collectionInstanceProductIdOfferingIdMap - product id to offering id map for instances of a collection
 * @param offeringsAndpricingPlans - offerings and pricing plans data
 * @returns Record<string, Partial<CartProductSchema>>
 * Updated instances object with offering id and offering name
 */
export const getUpdatedSelectedInstancesOffering = ({
  initialProducts,
  selectedProducts,
  collectionInstanceProductIdOfferingIdMap,
  offeringsAndpricingPlans,
}: {
  initialProducts: Record<string, CartProductSchema | CartLinkedEntitlementsSchema>;
  selectedProducts: Record<string, Partial<CartProductSchema | CartLinkedEntitlementsSchema>>;
  collectionInstanceProductIdOfferingIdMap: Record<string, string>;
  offeringsAndpricingPlans?: State['offeringsAndpricingPlans'];
}) => {
  if (Object.keys(selectedProducts)?.length === 0) {
    return [];
  }

  const updatedInstancesObj = Object.keys(selectedProducts).map((instanceId) => {
    let updatedChangeObj: Partial<CartProductSchema> = {};
    const instanceProductId = selectedProducts[instanceId]?.productId;
    const updatedOfferingId = instanceProductId ? collectionInstanceProductIdOfferingIdMap[instanceProductId] : null;
    if (updatedOfferingId) {
      updatedChangeObj = {
        offeringId: updatedOfferingId,
        offeringName: instanceProductId
          ? offeringsAndpricingPlans?.[instanceProductId]?.find(({ id }) => id === updatedOfferingId)?.offeringName ??
            ''
          : '',
      };
    }

    const selectedProductDiffObj = initialProducts[instanceId]
      ? getShallowDiffObject(initialProducts[instanceId], {
          ...selectedProducts[instanceId],
          ...updatedChangeObj,
        })
      : {};

    const productStatuses =
      initialProducts[instanceId] && getProductStatuses(selectedProductDiffObj, initialProducts[instanceId]);

    return {
      ...(initialProducts[instanceId] && {
        [instanceId]: {
          ...selectedProductDiffObj,
          productStatuses,
        },
      }),
    };
  });

  return updatedInstancesObj;
};
